import {EmployBridge} from './EmployBridge';
import BranchDesktopBase from '../BranchDesktopBase';

export class BranchDesktopEmployBridge extends EmployBridge {
    constructor() {
        super();
        this.setEmployBridgeBranchDesktopColors();
    }

    private setEmployBridgeBranchDesktopColors() {
        this.colors.general.primaryColor = '#44505e';
        this.colors.general.secondaryColor = '#8C3B32';
        this.colors.general.tertiaryColor = '#a26059';
        this.colors.background.blueBackgroundColor = '#44505e';
    }
}

const branchDesktopEmployBridgeTheme = BranchDesktopBase.setShareStyles(new BranchDesktopEmployBridge());
export default branchDesktopEmployBridgeTheme;



// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/themes/EmployBridge/branch-desktop.ts